import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AppNavbar from "./AppNavbar";

const API_BASE = 'https://hospital.rozeetechnist.com/hospital-api';

const ContributionCreate = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState({ title: '', amount: '', description: '', status: 'active' });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem('login')) navigate('/login');
    }, [navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const getUserId = () => {
        try {
            const l = localStorage.getItem('login');
            return l ? JSON.parse(l).id : null;
        } catch (e) { return null; }
    };

    const handleSubmit = () => {
        if (!form.title.trim()) { toast.error('Enter Title'); return; }
        const amt = form.amount === '' || isNaN(parseFloat(form.amount)) ? 0 : parseFloat(form.amount);
        if (amt < 0) { toast.error('Amount cannot be negative'); return; }
        const uid = getUserId();
        if (!uid) { toast.error('Please login again'); return; }

        setLoading(true);
        fetch(API_BASE + '/createContribution.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                title: form.title.trim(),
                amount: amt,
                description: form.description.trim(),
                status: form.status,
                created_by: uid
            })
        })
            .then(res => res.json())
            .then(resp => {
                setLoading(false);
                if (resp.status) { toast.success(resp.message); navigate('/contribution-list'); }
                else toast.error(resp.message || 'Failed');
            })
            .catch(() => { setLoading(false); toast.error('Error'); });
    };

    return (
        <div>
            <AppNavbar />
            <div className="container">
                <div className="row top-page-bar">
                    <div className="col-9"><div className="main-title"><h1>Add Contribution</h1></div></div>
                    <div className="col-3"><Link className="btn btn-secondary" to="/contribution-list">Back</Link></div>
                </div>
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label">Title *</label>
                        <input className="form-control" name="title" value={form.title} onChange={handleChange} placeholder="Title" required />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Amount</label>
                        <input type="number" step="0.01" min="0" className="form-control" name="amount" value={form.amount} onChange={handleChange} placeholder="Amount (optional)" />
                    </div>
                    <div className="col-12">
                        <label className="form-label">Description</label>
                        <textarea className="form-control" name="description" value={form.description} onChange={handleChange} placeholder="Description" rows={3} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Status</label>
                        <select className="form-control" name="status" value={form.status} onChange={handleChange}>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                    <div className="col-12">
                        <button className="btn btn-primary btn-lg" onClick={handleSubmit} disabled={loading}>{loading ? 'Saving...' : 'Submit'}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContributionCreate;
